<overlay-legend></overlay-legend>
<ac-layermanager></ac-layermanager>
<location-switcher></location-switcher>